import Certificates from '@classes/Certificates'
import Collapse from '@components/Collapse'
import { GetAchievementsResponse } from '@interfaces/Achievements'
import * as React from 'react'
import { useEffect, useState } from 'react'
import CertificatePanelContent from './CertificatePanelContent'
import { useSelector } from 'react-redux'
import { StoreProps } from '@interfaces/StoreState'
import EmptyState from '@components/EmptyState'
import Spacer from '@berlitz/spacer'

const CertificateContent: React.FC<{ data?: GetAchievementsResponse }> = ({ data }) => {
  const studentProfile = useSelector(
    ({ userProfile }: StoreProps) => userProfile?.info?.StudentProfile?.StudentProfileInfo
  )
  const [certData, setCertData] = useState(
    data?.getAchievements?.data ? new Certificates(data?.getAchievements.data, studentProfile) : undefined
  )

  useEffect(() => {
    setCertData(data?.getAchievements?.data ? new Certificates(data?.getAchievements.data, studentProfile) : undefined)
  }, [data])

  if (!certData?.GroupedCertificates?.length) {
    return (
      <>
        <Spacer size="xl" />
        <EmptyState heading="No certificates found" img="/images/lost.svg" />
        <Spacer size="xl" />
      </>
    )
  }

  return (
    <Collapse activeIds={[certData?.GroupedCertificates?.[0]?.[0]?.registrationId]}>
      {certData?.GroupedCertificates.map((certs, i) => {
        return (
          <Collapse.Panel
            key={certs[0].registrationId}
            id={certs[0].registrationId || `certificates-${i}`}
            header={certs[0].coreName}
            hideOnly
          >
            <CertificatePanelContent certs={certs} />
          </Collapse.Panel>
        )
      })}
    </Collapse>
  )
}

export default CertificateContent
